<div class="admin-layout">
  <aside class="sidebar">
    <div class="sidebar-brand">
      <img class="brand-logo" src="/assets/logo/bg_remove_white.png" alt="KinSphere360" />
    </div>

    <nav class="sidebar-nav" aria-label="Admin navigation">
      <span class="nav-group-label">Overview</span>
      <a class="nav-item" routerLink="/admin/dashboard" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3.5" y="3.5" width="7" height="8.5" rx="1.6" />
          <rect x="13.5" y="3.5" width="7" height="5" rx="1.6" />
          <rect x="13.5" y="10.5" width="7" height="10" rx="1.6" />
          <rect x="3.5" y="14.5" width="7" height="6" rx="1.6" />
        </svg>
        <span>Dashboard</span>
      </a>

      <span class="nav-group-label nav-group-spaced">Management</span>
      <a class="nav-item" routerLink="/admin/users" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm7 8a7 7 0 0 0-14 0" />
        </svg>
        <span>Users</span>
      </a>
      <a class="nav-item" routerLink="/admin/groups" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20" />
          <circle cx="10" cy="7.5" r="3.5" />
          <path d="M20 20v-1.5a3.5 3.5 0 0 0-2.6-3.4M15.5 4.2a3.5 3.5 0 0 1 0 6.6" />
        </svg>
        <span>Groups</span>
      </a>
      <a class="nav-item" routerLink="/admin/subscriptions" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="5.5" width="18" height="13" rx="2.5" />
          <path d="M3 10h18M7 14.5h3" />
        </svg>
        <span>Subscriptions</span>
      </a>

      <a class="nav-item" routerLink="/admin/payments" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 3h9l4 4v14a1 1 0 0 1-1.5.9L15 20.5l-2.5 1.4-2.5-1.4-2.5 1.4L5 20.5V4a1 1 0 0 1 1-1Z" />
          <path d="M9 8h5M9 12h6M9 16h4" />
        </svg>
        <span>Payments</span>
      </a>

      <span class="nav-group-label nav-group-spaced">Configuration</span>
      <a class="nav-item" routerLink="/admin/plans" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
          <path d="m4.3 7.7 7.7 4.4 7.7-4.4M12 12.1V21" />
        </svg>
        <span>Plans</span>
      </a>
      <a class="nav-item" routerLink="/admin/coupons" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 9.5V7a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.5a2.5 2.5 0 0 0 0 5V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2.5a2.5 2.5 0 0 0 0-5Z" />
          <path d="M14.5 9.5 9.5 14.5" />
        </svg>
        <span>Coupons</span>
      </a>
      <a class="nav-item" routerLink="/admin/addons" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="3" width="18" height="18" rx="4" />
          <path d="M12 8.2v7.6M8.2 12h7.6" />
        </svg>
        <span>Add-ons</span>
      </a>
      <a class="nav-item" routerLink="/admin/app-versions" routerLinkActive="active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <rect x="7" y="2.5" width="10" height="19" rx="2" />
          <path d="M10 5.5h4M10 18.5h4M12 9v5M9.5 11.5 12 14l2.5-2.5" />
        </svg>
        <span>Mobile App</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <div class="user-chip">
        <span class="user-initials">{{ initials() }}</span>
        <div class="user-info">
          <span class="user-name">{{ displayName() }}</span>
          <span class="user-role">Admin</span>
        </div>
      </div>
      <button class="btn btn-ghost btn-sm logout-btn" type="button" (click)="logout()">
        Logout
      </button>
    </div>
  </aside>

  <main class="main-area">
    <router-outlet></router-outlet>
  </main>
</div>
